// Local demo seeds for the automations compat module.
// These records are not backed by a persistent backend domain.
import {
  BarChart3,
  Bell,
  Calculator,
  Calendar,
  FileSignature,
  Mail,
  Users,
} from '../../../shared/assets/AppIcons';

export const localAutomationTimeFilterOptions = [
  { id: 'giorno', label: 'Oggi' },
  { id: 'settimana', label: 'Settimana' },
  { id: 'mese', label: 'Mese' },
  { id: 'trimestre', label: 'Trimestre' },
  { id: 'all', label: 'Tutti' },
];

export const localAutomationUsageByPeriodSeed = {
  giorno: [
    { giorno: '08:00', utilizzi: 1 },
    { giorno: '10:00', utilizzi: 2 },
    { giorno: '12:00', utilizzi: 0 },
    { giorno: '14:00', utilizzi: 1 },
    { giorno: '16:00', utilizzi: 1 },
    { giorno: '18:00', utilizzi: 0 },
  ],
  settimana: [
    { giorno: 'Lun', utilizzi: 3 },
    { giorno: 'Mar', utilizzi: 5 },
    { giorno: 'Mer', utilizzi: 2 },
    { giorno: 'Gio', utilizzi: 4 },
    { giorno: 'Ven', utilizzi: 6 },
    { giorno: 'Sab', utilizzi: 1 },
    { giorno: 'Dom', utilizzi: 0 },
  ],
  mese: [
    { giorno: 'Sett 1', utilizzi: 8 },
    { giorno: 'Sett 2', utilizzi: 12 },
    { giorno: 'Sett 3', utilizzi: 15 },
    { giorno: 'Sett 4', utilizzi: 12 },
  ],
  trimestre: [
    { giorno: 'Dic', utilizzi: 16 },
    { giorno: 'Gen', utilizzi: 24 },
    { giorno: 'Feb', utilizzi: 23 },
  ],
  all: [
    { giorno: 'Ott', utilizzi: 8 },
    { giorno: 'Nov', utilizzi: 12 },
    { giorno: 'Dic', utilizzi: 16 },
    { giorno: 'Gen', utilizzi: 24 },
    { giorno: 'Feb', utilizzi: 23 },
  ],
};

export const localAutomationUsageByUserSeed = {
  giorno: [
    { nome: 'Marco Rossi', utilizzi: 2, color: '#10b981' },
    { nome: 'Laura Bianchi', utilizzi: 2, color: '#3b82f6' },
    { nome: 'Giuseppe Verdi', utilizzi: 1, color: '#8b5cf6' },
    { nome: 'Anna Russo', utilizzi: 0, color: '#f59e0b' },
  ],
  settimana: [
    { nome: 'Marco Rossi', utilizzi: 8, color: '#10b981' },
    { nome: 'Laura Bianchi', utilizzi: 6, color: '#3b82f6' },
    { nome: 'Giuseppe Verdi', utilizzi: 4, color: '#8b5cf6' },
    { nome: 'Anna Russo', utilizzi: 3, color: '#f59e0b' },
  ],
  mese: [
    { nome: 'Marco Rossi', utilizzi: 18, color: '#10b981' },
    { nome: 'Laura Bianchi', utilizzi: 14, color: '#3b82f6' },
    { nome: 'Giuseppe Verdi', utilizzi: 9, color: '#8b5cf6' },
    { nome: 'Anna Russo', utilizzi: 6, color: '#f59e0b' },
  ],
  trimestre: [
    { nome: 'Marco Rossi', utilizzi: 25, color: '#10b981' },
    { nome: 'Laura Bianchi', utilizzi: 18, color: '#3b82f6' },
    { nome: 'Giuseppe Verdi', utilizzi: 12, color: '#8b5cf6' },
    { nome: 'Anna Russo', utilizzi: 8, color: '#f59e0b' },
  ],
  all: [
    { nome: 'Marco Rossi', utilizzi: 32, color: '#10b981' },
    { nome: 'Laura Bianchi', utilizzi: 24, color: '#3b82f6' },
    { nome: 'Giuseppe Verdi', utilizzi: 16, color: '#8b5cf6' },
    { nome: 'Anna Russo', utilizzi: 11, color: '#f59e0b' },
  ],
};

export const localActiveAutomationsSeed = [
  {
    id: 1,
    nome: 'Creazione Documenti',
    descrizione: 'Generazione automatica di Contratti e Mandati di Assistenza',
    icona: FileSignature,
    stato: 'attivo',
    ultimoUtilizzo: '2025-02-04T10:30:00',
    utilizziTotali: 83,
    utilizziMese: 47,
    tempoMedioRisparmiato: 25,
    costoMensile: 59.9,
    categoria: 'Documenti',
  },
];

export const localSuggestedAutomationsSeed = [
  {
    id: 101,
    nome: 'Email Automatiche',
    descrizione: 'Invio automatico di email di follow-up, promemoria scadenze e notifiche ai clienti',
    icona: Mail,
    categoria: 'Comunicazione',
    tempoRisparmiato: '~2 ore/settimana',
    costoStimato: 'EUR 19.90/mese',
    popolarita: 92,
  },
  {
    id: 102,
    nome: 'Calcolo Automatico Crediti',
    descrizione: 'Analisi e calcolo automatico del valore dei crediti fiscali da documenti caricati',
    icona: Calculator,
    categoria: 'Analisi',
    tempoRisparmiato: '~4 ore/settimana',
    costoStimato: 'EUR 39.90/mese',
    popolarita: 88,
  },
  {
    id: 103,
    nome: 'Report Automatici',
    descrizione: 'Generazione periodica di report su affari, incassi e performance del team',
    icona: BarChart3,
    categoria: 'Reporting',
    tempoRisparmiato: '~3 ore/settimana',
    costoStimato: 'EUR 24.90/mese',
    popolarita: 85,
  },
  {
    id: 104,
    nome: 'Notifiche Scadenze',
    descrizione: 'Alert automatici per scadenze documenti, pagamenti e task in ritardo',
    icona: Bell,
    categoria: 'Notifiche',
    tempoRisparmiato: '~1 ora/settimana',
    costoStimato: 'EUR 9.90/mese',
    popolarita: 95,
  },
  {
    id: 105,
    nome: 'Sincronizzazione Calendario',
    descrizione: 'Sincronizzazione automatica degli appuntamenti con Google Calendar e Outlook',
    icona: Calendar,
    categoria: 'Integrazione',
    tempoRisparmiato: '~30 min/settimana',
    costoStimato: 'EUR 14.90/mese',
    popolarita: 78,
  },
  {
    id: 106,
    nome: 'Assegnazione Intelligente',
    descrizione: 'Assegnazione automatica dei task al personale in base a competenze e carico',
    icona: Users,
    categoria: 'Gestione',
    tempoRisparmiato: '~2 ore/settimana',
    costoStimato: 'EUR 29.90/mese',
    popolarita: 72,
  },
];
